import { Route, Routes } from 'react-router-dom'
import { useCurrentUser } from '~/common'
import { PromoCodeFormPage, PromoCodeDetailsPage, PromoCodesPage } from '~/modules/promocodes/view'
import { PATH } from '~/AppRoutes'
import { AuthWrapped } from '~/modules/navigation/components'

export const PromocodesRoutes = () => {
  const { hasRole } = useCurrentUser()
  const canAccess = hasRole('PROMOCODES')
  return (
    <Routes>
      <Route index element={<AuthWrapped component={PromoCodesPage} canAccess={canAccess} />} />
      <Route
        path={`${PATH.DETAILS}/:id`}
        element={<AuthWrapped component={PromoCodeDetailsPage} canAccess={canAccess} />}
      />
      <Route path={PATH.ADD} element={<AuthWrapped component={PromoCodeFormPage} canAccess={canAccess} />} />
      <Route path={`${PATH.EDIT}/:id`} element={<AuthWrapped component={PromoCodeFormPage} canAccess={canAccess} />} />
    </Routes>
  )
}

export const promocodesLinks = {
  promoCodesLink: () => PATH.OVERVIEW,
  promoCodeDetailsLink: (id: string) => `/${PATH.DETAILS}/${id}`,
  addPromoCodeLink: () => `/${PATH.ADD}`,
  editPromoCodeLink: (id: string) => `/${PATH.EDIT}/${id}`,
}
